export const theme = {
  disclaimerTextColor: Styles.color.grey.one,
  rewardDescriptionColor: Styles.color.grey.one,
  rewardImageWidthDesktop: '35%',
};
